import script from "./ComprehensiveCheckDefinitionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ComprehensiveCheckDefinitionEditor.vue?vue&type=script&setup=true&lang=js"

import "./ComprehensiveCheckDefinitionEditor.vue?vue&type=style&index=0&id=616aa069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616aa069"]])

export default __exports__